import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-rapid-delivery-create',
  templateUrl: './admin-rapid-delivery-create.component.html',
  styleUrls: ['./admin-rapid-delivery-create.component.scss'],
})
export class AdminRapidDeliveryCreateComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
